class BaseService {
  handleHttpErrors = rspOrError => {
    if (rspOrError instanceof Error) {
      console.error('handleHttpErrors:', rspOrError)
      throw rspOrError
    } else {
      if (rspOrError.ok) return

      console.error(
        `handleHttpErrors: ${rspOrError.status}: ${rspOrError.statusText}`
      )

      if (
        rspOrError.status === 401 &&
        (window.location.pathname === '/joinus/login' ||
          window.location.pathname === '/joinus/register')
      ) {
        window.location.href = '/joinus/login'
      } else if (rspOrError.status === 401) {
        window.location.href = '/login'
      } else {
        throw new Error(`${rspOrError.status}: ${rspOrError.statusText}`)
      }
    }
  }
}

export default BaseService
